<app-overlay
  overlayTitle="Messages Panel"
  icon="info-panel"
  [resizable]="false"
  [active]="showInfoPanel"
>
  <ul class="list-group list-group-flush">
    <li class="list-group-item">
      <!-- Show Phoenix Current Version (ON by Default) -->
      Phoenix Version: {{ version }}
    </li>
    <li class="list-group-item" *ngIf="actionsList.length === 0">
      No actions.
    </li>
    <li class="list-group-item" *ngFor="let action of actionsList">
      {{ action }}
    </li>
  </ul>
</app-overlay>
